import React, { forwardRef } from "react";

const FormField = forwardRef(function FormField(
  {
    label,
    error,
    required,
    multiline,
    rows = 4,
    className = "",
    "data-testid": testId,
    inputClassName = "",
    ...rest
  },
  ref
) {
  const base =
    "w-full rounded-xl border bg-white px-4 py-3 text-sm font-medium text-sprouts-text placeholder:text-sprouts-muted focus:outline-none focus:ring-2 focus:ring-sprouts-primary/40 focus:border-sprouts-primary transition-colors";
  const errClass = error ? "border-sprouts-secondary" : "border-sprouts-border";

  return (
    <div className={`mb-4 ${className}`}>
      {label ? (
        <label className="block text-[13px] font-bold text-sprouts-text mb-1.5">
          {label}
          {required && <span className="text-sprouts-secondary"> *</span>}
        </label>
      ) : null}
      {multiline ? (
        <textarea
          ref={ref}
          rows={rows}
          data-testid={testId}
          className={`${base} ${errClass} resize-y min-h-[120px] ${inputClassName}`}
          {...rest}
        />
      ) : (
        <input
          ref={ref}
          data-testid={testId}
          className={`${base} ${errClass} ${inputClassName}`}
          {...rest}
        />
      )}
      {error ? (
        <p className="mt-1 text-xs text-sprouts-secondary font-semibold" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </p>
      ) : null}
    </div>
  );
});

export default FormField;
